export const GET_DEGREES_REQUEST='degreesReducer/GET_DEGREES_REQUEST';
export const GET_DEGREES_SUCCESS='degreesReducer/GET_DEGREES_SUCCESS';
export const GET_DEGREES_FAILED='degreesReducer/GET_DEGREES_FAILED';